import {Component, inject, OnInit} from '@angular/core';
import {CarouselComponent} from "../../../assets/shared/components/carousel/carousel.component";
import {OwlOptions} from "ngx-owl-carousel-o";
import {ActivatedRoute, Router} from "@angular/router";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {PaymentService} from "../../core/services/payment/payment.service";
import {Carousel} from "../../core/interface/carousel";

@UntilDestroy()
@Component({
  selector: 'check-unsubscription',
  imports: [
    CarouselComponent,

  ],
  standalone: true,
  templateUrl: './check-unsubscription.component.html',
  styleUrl: './check-unsubscription.component.scss'
})
export class CheckUnsubscriptionComponent implements OnInit {
  private paymentService = inject(PaymentService);
  carouselInfo: Carousel[] | undefined
  message: string = '';

  subMessage: string = '';
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navText: [
      '<img src="assets/images/ul-kit/left-arrow.svg">',
      '<img src="assets/images/ul-kit/right-arrow.svg">'
    ],

    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    },
    nav: true
  }


  constructor(private route: ActivatedRoute,
              private router: Router) {
    this.getInfoCodeUnsubscription()
  }

  ngOnInit() {

  }

  getInfoCodeUnsubscription() {
    this.route.params.subscribe((params) => {
      this.paymentService.checkUnsubscription(params['code']).subscribe({
        next: (res) => {
          if (res.status === 200) {
            this.router.navigate(['/confirm'], {state: {code: params['code']}});
          }
        },
        error: (err) => {
          if (err.status === 401) {
            this.updateMessage(err.status.toString());
          } else if (err.status === 400) {
            this.updateMessage(err.status.toString());
          } else if (err.status === 500) {
            this.router.navigate(['/']);
          }
        }
      });
    });
    this.getCarouselInfo();
  }


  updateMessage(code: string) {
    switch (code) {
      case '401':
        this.message = 'Ссылка больше не работает!';
        this.subMessage = 'Уведомляем вас, что ссылка больше не работает.\nПожалуйста, попробуйте найти подписку через страницу поиска.';
        break;
      case '400':
        this.message = 'Ссылка не работает!';
        this.subMessage = 'Уведомляем вас, что по техническим причинам ссылка не работает.\nПожалуйста, попробуйте снова найти подписку через страницу поиска.';
        break;
    }
  }

  getCarouselInfo() {
    this.paymentService.getCarouselInfo('c').pipe(untilDestroyed(this)).subscribe(carousel => {
      this.carouselInfo = carousel
    })
  }
}

